import { Bars } from "@gravity-ui/icons";
import { Button, Icon, TocItem } from "@gravity-ui/uikit";

import { KnowledgeDropdownToc } from "../KnowledgeDropdownToc";
import styles from "./KnowledgeHeader.module.scss";

interface KnowledgeHeaderProps {
  isMobileDialogOpen: boolean;
  onClick: (value: boolean) => void;
  activeId: string | null;
  items: TocItem[];
}

export const KnowledgeHeader = ({
  items,
  activeId,
  isMobileDialogOpen,
  onClick,
}: KnowledgeHeaderProps) => {
  return (
    <>
      <KnowledgeDropdownToc activeId={activeId} items={items} />
      <Button
        size={"xl"}
        tabIndex={-1}
        className={styles.button}
        onClick={() => onClick(!isMobileDialogOpen)}
      >
        <Icon data={Bars} size={36} />
      </Button>
    </>
  );
};
